module.exports = new __parcel__URL__("unranked.c642ff10.png").toString();